import { foldText } from './ColumnFilter/ColumnFilterTypes';

/**
 * Açılır listede seçeneğin aranan metne uyup uymadığı: Türkçe harf ve büyük/küçük harf farkı yok sayılır
 * (İ/I/ı/i, Ş/s, Ğ/g, Ü/u, Ö/o, Ç/c). Kolon filtreleriyle aynı katlama (foldText) kullanılır.
 *
 * Eskiden toLowerCase kullanılıyordu: "İSTANBUL" -> "i̇stanbul" (noktalı i iki karakter) olduğu için "ist" bulunmuyor,
 * "şişli" yazınca "SISLI" çıkmıyordu (05.10.2026, Anlaşma ekranı İl/İlçe).
 */
export const aramayaUyar = (_etiket: string | undefined | null, _aranan: string | undefined | null): boolean => {
    const aranan = foldText((_aranan ?? '').trim());

    if (aranan == '')
        return true;

    return foldText(_etiket ?? '').includes(aranan);
}
